const replaceItem = (collection, item: unknown, index: number) => {
  const replaced = collection.map((i, indx) => (indx === index ? item : i));
  if (collection.meta) {
    replaced.meta = collection.meta;
  }
  return replaced;
};

export default replaceItem;
